import type { CSSProperties } from 'react';

import type { PresenceStatus } from '@/types/realtime';

export const getPresenceAvatarOpacity = (status?: PresenceStatus) => {
    if (status === 'online') {
        return 1;
    }

    if (status === 'away') {
        return 0.65;
    }

    return 0.3;
};

export const getPresenceAvatarStyle = (status?: PresenceStatus): CSSProperties => ({
    opacity: getPresenceAvatarOpacity(status),
    transition: 'opacity 0.25s ease',
});
